import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import { Tooltip } from '@mui/material';
import { BrandContext } from '../../../contexts/BrandContext';
import { statusMap } from './StatusMap';


export default function ProgressIcon(props) {
  
    let handleClick = () => {};
  
    const {
        taxiBooking:{
            taxiBookingJobs=[],
        },
        onClick
    } = props;
    
    let statusId = 1;

    if(onClick){
        handleClick = () => {
            onClick();
        }
    }


    if(taxiBookingJobs.length > 0){
        for(let i=0; i<taxiBookingJobs.length; i+=1){
            if(taxiBookingJobs[i].isActive){
                const taxiBookingJob = taxiBookingJobs[i];
                ({
                    status:{
                        id:statusId
                    },
                } = taxiBookingJob);
                break;
            }
        }
    }
    
    const statusIconSetup = statusMap[statusId];

    const {
        icon,
        percent,
        backgroundColor,
        inMotion,
        tooltipText
    } = statusIconSetup;

    const buttonSx = {
        bgcolor: backgroundColor,
        '&:hover': {
            bgcolor: backgroundColor,
        },
    }


    const brandContext = useContext(BrandContext);
    const {textContent} = brandContext;
    const toolTip = textContent[tooltipText];
    

  return (
    <>
    <Box sx={{ display: 'flex', alignItems: 'center', cursor:'pointer' }} onClick={() => { handleClick()}}>
        <Tooltip title={toolTip}>
            <Box sx={{ m: 1, position: 'relative' }}>        
                <Fab
                aria-label="save"
                size="small"
                color="primary"
                sx={buttonSx}
                >
                {icon}
                </Fab>
                <CircularProgress
                    size={48}
                    variant={inMotion ? "indeterminate" : "determinate"}
                    value={percent}
                    sx={{
                    color: green[500],
                    position: 'absolute',
                    top: -4,
                    left: -4,
                    zIndex: 1,
                    }}
                />
            </Box>
        </Tooltip>
        
    </Box>
   
    </>
  );
}